module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Медицински Център Тринити София","short_name":"МЦ Тринити","start_url":"/","background_color":"#F8F8F8","theme_color":"#A3AAC3","display":"standalone","icon":"src/assets/images/logo-trinity-white.2.png","icons":[{"src":"src/assets/images/logo-trinity-white.2.png","sizes":"192x192","type":"image/png"},{"src":"src/assets/images/logo-trinity-white.2.png","sizes":"512x512","type":"image/png"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"518b68072b162fd4c772dec45e7e80b2"},
    },{
      plugin: require('../node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
